import { ArrowUpRight, Linkedin, Mail } from "lucide-react";
import { contatti, site, en } from "@/content";
import { useLang } from "@/lang";
import MacWindow from "@/components/MacWindow";
import Reveal, { MaskedLine } from "@/components/Reveal";

export default function Contatti() {
    const { lang } = useLang();
    const co = lang === "en" ? en.contatti : contatti;
    const s = lang === "en" ? en.site : site;
    return (
        <MacWindow id="contatti" testId="contatti-section" title={co.windowTitle} icon="mail" dark>
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-paper/60">
                    {co.overline}
                </p>
            </Reveal>
            <h2 className="mt-6 font-display text-[clamp(3rem,9vw,7.5rem)] leading-[0.95] tracking-tight">
                <MaskedLine key={lang}>
                    <em>{co.heading}</em>
                </MaskedLine>
            </h2>
            <Reveal delay={0.1}>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-paper/70 md:text-lg">
                    {co.note}
                </p>
            </Reveal>

            <Reveal delay={0.15} className="mt-12 md:mt-16">
                <a
                    href={`mailto:${s.email}?subject=${encodeURIComponent(s.emailSubject)}`}
                    data-testid="email-link"
                    className="group flex items-center justify-between gap-4 border-t-2 border-paper/30 py-7 transition-colors duration-150 hover:bg-paper hover:text-ink md:py-8"
                >
                    <span className="flex items-center gap-4 break-all font-display text-xl tracking-tight md:gap-6 md:text-4xl">
                        <Mail className="h-5 w-5 shrink-0 opacity-60 md:h-7 md:w-7" />
                        {s.email}
                    </span>
                    <ArrowUpRight className="h-6 w-6 shrink-0 opacity-60 transition-transform duration-150 group-hover:-translate-y-1 group-hover:translate-x-1 md:h-7 md:w-7" />
                </a>
                <a
                    href={s.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="linkedin-link"
                    className="group flex items-center justify-between gap-4 border-y-2 border-paper/30 py-7 transition-colors duration-150 hover:bg-paper hover:text-ink md:py-8"
                >
                    <span className="flex items-center gap-4 break-all font-display text-xl tracking-tight md:gap-6 md:text-4xl">
                        <Linkedin className="h-5 w-5 shrink-0 opacity-60 md:h-7 md:w-7" />
                        {s.linkedinLabel}
                    </span>
                    <ArrowUpRight className="h-6 w-6 shrink-0 opacity-60 transition-transform duration-150 group-hover:-translate-y-1 group-hover:translate-x-1 md:h-7 md:w-7" />
                </a>
            </Reveal>

            <Reveal delay={0.2}>
                <p
                    data-testid="thanks-note"
                    className="mt-12 max-w-xl border-t-2 border-paper/30 pt-7 text-base leading-relaxed text-paper/60"
                >
                    {co.thanks}
                </p>
            </Reveal>

            <footer
                data-testid="site-footer"
                className="mt-10 flex flex-col gap-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-paper/50 md:flex-row md:items-center md:justify-between"
            >
                <span>
                    © {new Date().getFullYear()} {s.name}
                </span>
                <a
                    href="#privacy"
                    onClick={(e) => {
                        e.preventDefault();
                        const el = document.querySelector("#privacy");
                        if (!el) return;
                        if (window.__lenis) {
                            window.__lenis.scrollTo(el, { offset: -60, duration: 1.2 });
                        } else {
                            el.scrollIntoView({ behavior: "smooth" });
                        }
                    }}
                    data-testid="footer-privacy-link"
                    className="px-1 transition-colors duration-150 hover:bg-paper hover:text-ink"
                >
                    Privacy
                </a>
                <span>🖥️ {co.footerTag}</span>
            </footer>
        </MacWindow>
    );
}
